<script lang="ts">
// BaseLayout's cart request, in a child of its own so that on the server only this component waits for it and the
// page's own requests go out alongside it. The cart readers wait for it through useCartStore() (stores/cart.ts explains
// which do). Renders nothing.
import { useCartStore } from '~/stores/cart'

export default defineComponent({
  props: {
    navCart: { type: Boolean, required: true }
  },
  setup (props) {
    const cartStore = useCartStore()
    const nuxtApp = useNuxtApp()

    useAsyncData('layout-base', async () => {
      if (props.navCart) {
        await cartStore.fetchCart()
        // runWithContext: the handler resumes after awaits, where the Nuxt instance context is
        // lost, and the telemetry composable reads useNuxtApp()/useRequestHeaders(). Without it
        // the SSR pass logs NUXT_E1001 per request and sees no request headers.
        nuxtApp.runWithContext(() => useAnonymousCartPreAttributionTelemetry())
      }
      return true
    })

    return () => null
  }
})
</script>
